import { useState, useEffect } from 'react';

/**
 * Fetches live FLR/USD price from CoinGecko API
 * Updates every ~3 minutes
 * Fallback from FTSO oracle which doesn't work reliably on public RPC endpoints
 */
export function useFlarePriceFTSO() {
  const [flrPriceUSD, setFlrPriceUSD] = useState(null);
  const [timestamp, setTimestamp] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        console.log('[useFlarePriceFTSO] Fetching FLR price from CoinGecko');

        const response = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=flare-networks&vs_currencies=usd&include_last_updated_at=true'
        );

        if (!response.ok) {
          throw new Error(`CoinGecko API returned ${response.status}`);
        }

        const data = await response.json();
        console.log('[useFlarePriceFTSO] CoinGecko result:', data);

        if (!data['flare-networks'] || !data['flare-networks'].usd) {
          throw new Error('Invalid response from CoinGecko');
        }

        const priceUSD = data['flare-networks'].usd;
        const lastUpdated = data['flare-networks'].last_updated_at;

        console.log('[useFlarePriceFTSO] FLR price:', priceUSD, 'USD, updated:', new Date(lastUpdated * 1000));

        setFlrPriceUSD(priceUSD);
        setTimestamp(lastUpdated);
        setIsLoading(false);
      } catch (error) {
        console.error('[useFlarePriceFTSO] Error fetching FLR price:', error);
        setFlrPriceUSD(null);
        setIsLoading(false);
      }
    };

    fetchPrice();
    const interval = setInterval(fetchPrice, 180000); // Refresh every 3 minutes
    return () => clearInterval(interval);
  }, []);

  return {
    flrPriceUSD,
    timestamp,
    isLoading
  };
}
